import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react'

import { ProductHeaderProps } from '~/components/UI/ProductHeader'

const Context = createContext<PackProductsProviderContext>(null)

export interface PackProductsProviderContext {
  data?: ProductHeaderProps['shopifyProduct'][][]
  setData?: Dispatch<SetStateAction<ProductHeaderProps['shopifyProduct'][][]>>
}

export interface PackProductsProviderProps {
  children?: ReactNode | ReactNode[]
  pack?: ProductHeaderProps['shopifyProduct'][][]
}

export function usePackProductsProvider() {
  return useContext(Context)
}

function PackProductsProvider({ children, pack }: PackProductsProviderProps) {
  const [data, setData] = useState(pack)

  const providerValue = useMemo(
    () => ({
      data,
      setData,
    }),
    [data],
  )

  return <Context.Provider value={providerValue}>{children}</Context.Provider>
}

export default PackProductsProvider
